export default __webpack_public_path__ + "static/media/loader.ea26dbe0.svg";